module.exports = __webpack_public_path__ + "img/grichkarip.aed2fb4c.jpg";